import { render, staticRenderFns } from "./CouponIndex.vue?vue&type=template&id=5299e9b8&scoped=true&"
import script from "./CouponIndex.vue?vue&type=script&lang=js&"
export * from "./CouponIndex.vue?vue&type=script&lang=js&"
import style0 from "./CouponIndex.vue?vue&type=style&index=0&id=5299e9b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5299e9b8",
  null
  
)

export default component.exports